import { Record, Union } from "./fable_modules/fable-library.3.7.20/Types.js";
import { Page$reflection as Page$reflection_1 } from "./Containers/Billing/Model.js";
import { Page$reflection as Page$reflection_2 } from "./Containers/ClientSettings/Model.js";
import { Page$reflection as Page$reflection_3 } from "./Containers/Contracts/View.js";
import { Page$reflection as Page$reflection_4 } from "./Containers/CustomerContract/Model.js";
import { Page$reflection as Page$reflection_5 } from "./DevTools/Base.js";
import { Page$reflection as Page$reflection_6 } from "./Admin/Base.js";
import { Page$reflection as Page$reflection_7 } from "./Containers/StatusAndWarnings/Model.js";
import { Page$reflection as Page$reflection_8 } from "./Containers/NumberInventory/Model.js";
import { Page$reflection as Page$reflection_9 } from "./Containers/Reports/Model.js";
import { Page$reflection as Page$reflection_10 } from "./Containers/Imports/Model.js";
import { record_type, option_type, class_type, union_type, string_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.20/Choice.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Login", "Billing", "ClientSettings", "EditTemplates", "Contracts", "CustomerContractBase", "DevTools", "Admin", "Register", "StatusAndWarnings", "M2MSimList", "Suspense", "MortgageValidation", "NumberInventory", "Reports", "Imports", "AdmittanceUsers", "ClientDetails", "Iframe", "NotFound", "SessionContextLoading", "LinkAccount"];
    }
}

export function Page$reflection() {
    return union_type("App.Model.Page", [], Page, () => [[], [["Item", Page$reflection_1()]], [["Item", Page$reflection_2()]], [], [["Item", Page$reflection_3()]], [["Item", Page$reflection_4()]], [["Item", Page$reflection_5()]], [["Item", Page$reflection_6()]], [], [["Item", Page$reflection_7()]], [], [], [], [["Item", Page$reflection_8()]], [["Item", Page$reflection_9()]], [["Item", Page$reflection_10()]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [], [], []]);
}

export class SessionResponse extends Record {
    constructor(FableScripts, SiteWideMessage) {
        super();
        this.FableScripts = FableScripts;
        this.SiteWideMessage = SiteWideMessage;
    }
}

export function SessionResponse$reflection() {
    return record_type("App.Model.SessionResponse", [], SessionResponse, () => [["FableScripts", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])], ["SiteWideMessage", option_type(string_type)]]);
}

export class ActiveSessionResponse extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ResponseOk", "ResponseUnauthorized", "ResponseError"];
    }
}

export function ActiveSessionResponse$reflection() {
    return union_type("App.Model.ActiveSessionResponse", [], ActiveSessionResponse, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

